export default __webpack_public_path__ + "static/media/switchOff.becb2a59.svg";